import api from "@/api.js";
// import testData from "@/assets/testDataIncludingPastScan.json";
import { normalizeStart } from "@/plugins/normalizingData.js";

async function loadGroupedDataInParallel(data, zoom) {
  // console.log(data);
  let arrayOfRequests = [];
  data.forEach(ids => {
    arrayOfRequests.push(loadSurveyDataInParallel(ids, zoom));
  });
  return await Promise.all(arrayOfRequests);
}

async function loadSurveyDataInParallel(data, zoom) {
  let arrayOfRequests = [];
  data.forEach(id => {
    arrayOfRequests.push(
      api.get("scheduledSurveys/getNormalizedData", {
        params: {
          idList: [id],
          zoom: zoom
        }
      })
    );
  });
  return await Promise.all(arrayOfRequests);
}

export default {
  state: {
    surveyReports: [],
    surveyReportsLoading: false,
    currentZoom: 0,
    currentZoomScanData: [],
    currentZoomScanDataLoading: false,
    currentMapIndex: 0,
    currentSelectedPoint: {},
    currentSelectedIndex: 0,
    currentSelectedIndexRelative: 0,
    currentViewedReports: [],
    selectedMergingScan: null,
    currentViewedReportsToBeFlipped: []
  },
  mutations: {
    setSurveyReports(state, payload) {
      state.surveyReports = payload;
    },
    setSurveyReportsLoading(state, payload) {
      state.surveyReportsLoading = payload;
    },
    setCurrentZoomScanData(state, payload) {
      state.currentZoomScanData = payload;
    },
    setCurrentZoomScanDataLoading(state, payload) {
      state.currentZoomScanDataLoading = payload;
    },
    setCurrentZoom(state, payload) {
      state.currentZoom = payload;
    },
    setCurrentMapIndex(state, payload) {
      state.currentMapIndex = payload;
    },
    setCurrentSelectedIndex(state, payload) {
      state.currentSelectedIndex = payload;
    },
    setCurrentSelectedIndexRelative(state, payload) {
      state.currentSelectedIndexRelative = payload;
    },
    setCurrentViewedReports(state, payload) {
      state.currentViewedReports = payload;
    },
    setSelectedMergingScan(state, payload) {
      state.selectedMergingScan = payload;
    },
    setCurrentViewedReportsToBeFlipped(state, payload) {
      if (payload) {
        state.currentViewedReportsToBeFlipped = payload;
      } else {
        state.currentViewedReportsToBeFlipped = [];
      }

    }
  },
  actions: {
    async loadSurveyReports({ commit }, id) {
      commit("setSurveyReportsLoading", true);
      let surveyReports = await api.get("scheduledSurveys/getSurveyObj", {
        params: {
          id: id
        }
      });

      commit("setSurveyReports", surveyReports.data);
      // commit("setSurveyReports", testData);
      commit("setSurveyReportsLoading", false);
    },
    async loadSurveyScanDataForZoom({ commit, state, rootState }, payload) {
      commit("setCurrentZoomScanDataLoading", true);
      commit("setCurrentViewedReports", payload.idList);
      commit("setCurrentViewedReportsToBeFlipped", payload.toBeFlipped);
      console.log(state);

      await loadGroupedDataInParallel(payload.idList, payload.zoom).then(
        result => {
          let data = [];

          result.forEach((surveys) => {
            surveys.forEach((survey) => {
              if (state.currentViewedReportsToBeFlipped.includes(survey.data[0]['id'])) {
                // reverse the data in array normalizedData
                survey.data[0].normalizedData.reverse();
              }
            });
          });

          // Looping over each Group (Either survey or merged survey)
          result.forEach((group, index) => {
            if (index == 0) {
              if (rootState.scheduledSurveys.survey) {
                data.push(rootState.scheduledSurveys.survey);
              } else {
                data.push(group[0]);
              }
              data[index].normalizedData = [];
            }

            group.forEach((survey, surveyIndex) => {
              // If it is not the first survey then create another survey in Data and push the surveys base data, then remove NormalizedData
              if (index != 0 && surveyIndex == 0) {
                data.push(JSON.parse(JSON.stringify(survey.data[0])));
                data[index].normalizedData = [];
              }

              // Append survey data to normalized Data
              data[index]["normalizedData"].push(
                ...survey.data[0].normalizedData
              );
            });
          });

          console.log(data);

          if (data.length > 1 && !payload.disableNormalization) {
            data = normalizeStart(data);
          }
          commit("setCurrentZoomScanData", data);
          commit("setCurrentZoom", payload.zoom);
          // commit("setSurveyReports", testData);
          commit("setCurrentZoomScanDataLoading", false);
        }
      );
    },
    async changeCurrentMapIndex({ commit }, index) {
      commit("setCurrentMapIndex", index);
    },
    async changeSelectedPoint({ commit, state }, point) {
      commit("setCurrentSelectedPoint", point);
      let index = state.currentZoomScanData[
        state.currentMapIndex
      ].normalizedData.findIndex(p => p.id == point.id);
      commit("setCurrentSelectedIndex", index);
    },
    async changeSelectedIndex({ commit, state }, index) {
      commit("setCurrentSelectedIndex", index);
      let relativePosition =
        index /
        state.currentZoomScanData[state.currentMapIndex].normalizedData.length;

      commit("setCurrentSelectedIndexRelative", relativePosition);
    },
    async updateSelectedMergingScan({ commit }, payload) {
      commit("setSelectedMergingScan", payload);
    },
    async addSurveyToSurveyReport({ state, commit }, id) {
      commit("setSurveyReportsLoading", true);
      let surveyReports = await api.get("scheduledSurveys/getSurveyObj", {
        params: {
          id: id
        }
      });

      let reports = JSON.parse(JSON.stringify(state.surveyReports));
      reports.push(surveyReports.data[0]);

      commit("setSurveyReports", normalizeStart(reports));
      commit("setSurveyReportsLoading", false);
    },
    async removeSurveyToSurveyReport({ state, commit }, id) {
      commit("setSurveyReportsLoading", true);
      let reports = JSON.parse(JSON.stringify(state.surveyReports));

      commit(
        "setSurveyReports",
        normalizeStart(reports.filter(survey => survey.id != id))
      );
      commit("setSurveyReportsLoading", false);
    },

    async resetSurveyReports({ commit }) {
      commit("setSurveyReports", []);
      commit("setCurrentZoom", 0);
      commit("setCurrentZoomScanData", []);
      commit("setCurrentMapIndex", 0);
      // commit("setCurrentSelectedPoint", {});
      commit("setCurrentSelectedIndex", 0);
      commit("setCurrentSelectedIndexRelative", 0);
      commit("setCurrentViewedReports", []);
      commit("setSelectedMergingScan", null);
    }
  },
  getters: {
    surveyReports(state) {
      return state.surveyReports;
    },
    surveyReportsLoading(state) {
      return state.surveyReportsLoading;
    },
    currentZoom(state) {
      return state.currentZoom;
    },
    currentZoomScanData(state) {
      return state.currentZoomScanData;
    },
    currentZoomScanDataLoading(state) {
      return state.currentZoomScanDataLoading;
    },
    currentMapIndex(state) {
      return state.currentMapIndex;
    },
    currentSelectedIndex(state) {
      return state.currentSelectedIndex;
    },
    currentSelectedIndexRelative(state) {
      return state.currentSelectedIndexRelative;
    },
    currentViewedReports(state) {
      return state.currentViewedReports;
    },
    selectedMergingScan(state) {
      return state.selectedMergingScan;
    },
    currentViewedReportsToBeFlipped(state) {
      return state.currentViewedReportsToBeFlipped;
    }
  }
};
